import React, { PureComponent } from 'react';

import { Configuration } from 'components/configuration';
import { Toggle } from 'components/toggle';
import { I18n, translate } from 'components/translate';
import PropTypes from 'prop-types';

@translate()
class OptionsConfiguration extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    onChange: PropTypes.func,
    fields: PropTypes.object
  };

  constructor(props) {
    super(props);

    const { t } = props;

    this.toggleLabels = {
      on: t('general.yes'),
      off: t('general.no')
    };
  }

  render() {
    const { fields, onChange } = this.props;

    return (
      <Configuration
        className="options-configuration"
        data-test="options-configuration"
        title={<I18n label="config_manager.title" />}
      >
        <Configuration.Item
          key="instant-topic-approval"
          title={<I18n label="community.configuration.automatic_topic_title" />}
          description={
            <I18n label="community.configuration.automatic_topic_explain" />
          }
          trailing={
            <Toggle
              label={this.toggleLabels}
              name="instantTopicApproval"
              checked={fields.instantTopicApproval}
              onChange={onChange}
              id="instantTopicApproval"
            />
          }
        />
        <Configuration.Item
          key="instant-reply-approval"
          title={
            <I18n label="community.configuration.automatic_answer_title" />
          }
          description={
            <I18n label="community.configuration.automatic_answer_explain" />
          }
          trailing={
            <Toggle
              label={this.toggleLabels}
              name="instantReplyApproval"
              checked={fields.instantReplyApproval}
              onChange={onChange}
              id="instantReplyApproval"
            />
          }
        />
        <Configuration.Item
          key="comment-all-classes"
          title={
            <I18n label="community.configuration.view_comments_from_all_classes_title" />
          }
          description={
            <I18n label="community.configuration.view_comments_from_all_classes_description" />
          }
          trailing={
            <Toggle
              label={this.toggleLabels}
              name="commentForAllClasses"
              checked={fields.commentForAllClasses}
              onChange={onChange}
              id="commentForAllClasses"
            />
          }
        />
        <Configuration.Item
          key="active"
          title={
            <I18n label="community.configuration.automatic_activate_title" />
          }
          description={
            <I18n label="community.configuration.automatic_activate_explain" />
          }
          trailing={
            <Toggle
              label={this.toggleLabels}
              name="active"
              checked={fields.active}
              onChange={onChange}
              id="active"
            />
          }
        />
      </Configuration>
    );
  }
}

export default OptionsConfiguration;
